<template>
  <div id="vin_create" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <span class="page-title" id="srtHeader">Review User Concern</span>
          <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="FeedBackLink">
            <i class="fp-back"> </i> Back
          </button>
        </div>
        <div class="container-fluid">
          <div id="customer-detail" class="admin-page-content customer-view list-view">
            <section class="internal-container border-top-table-fl">
              <div style="display: flex; justify-content: center; align-items: center; margin-bottom: 15px">
                <img :src="logoPath" alt="Dealer Pro" style="height: 35px; margin-right: 7px">
                <span
                  style="font-weight: bold; font-style: italic; color:#012d6b; font-size: 18px;margin-right: 7px">
                    DealerPro
                  </span>
                <img :src="flagPath" alt="Country Flag" style="margin-left: 0px; height: 35px">
              </div>
              <div class="col form-group">
                <h4>User Concern Information</h4>
              </div>
              <div class="col form-row section-divider">
                <div class="col-md-6" style="border-right: 1px solid #dddddd">
                  <div class="row form-group">
                    <label class="col">Ticket #:</label>
                    <span class="col"> {{ ticketNumber }} </span>
                  </div>
                  <div class="row form-group">
                    <label class="col">Status:</label>
                    <span class="col">{{ titleCase(status)  }} </span>
                  </div>
                  <div class="row form-group">
                    <label class="col"> Category:</label>
                    <span class="col"> {{ category }} </span>
                  </div>
                  <div class="row form-group">
                    <label class="col">Submit Date:</label>
                    <span class="col"> {{ submitDate }} </span>
                  </div>

                </div>
                <div class="col-md-6">
                  <div class="row form-group">
                    <label class="col"> User:</label>
                    <span class="col"> {{ user }} </span>
                  </div>
                  <div class="row form-group">
                    <label class="col"> Name:</label>
                    <span class="col"> {{ name }} </span>
                  </div>
                  <div class="row form-group">
                    <label class="col">Email:</label>
                    <span class="col"> {{ email }} </span>
                  </div>
                  <div class="row form-group">
                    <label class="col">Phone:</label>
                    <span class="col"> {{ phone }} </span>
                  </div>
                </div>
              </div>

              <div v-if="dropZonePreviewFiles.length > 0 && userFeedbackId > 0" class="col form-group section-divider">
                <div class="col form-group pl-0">
                  <h4>Uploaded Attachment(s)</h4>
                </div>
                <div class="col-md-5 pl-0">
                    <div class="policy-attachment attachment-list-box">
                      <template v-for="(uFile, fKey) in dropZonePreviewFiles">
                        <div v-bind:key="'fileDiv' + fKey" class="attachment-list">
                          <i v-if="uFile.extension == 'pdf'" class="fp-pdf-icon"></i>
                          <i v-if="uFile.extension == 'doc' ||
                            uFile.extension == 'docs' ||
                            uFile.extension == 'docx'" class="fp-text-document"></i>
                          <i v-if="uFile.extension == 'jpg' ||
                            uFile.extension == 'png' ||
                            uFile.extension == 'jpeg'" class="fp-image"></i>
                          <a title="View File" href="javascript:void(0)" v-on:click="
                            goToGetDocumentPath($event, uFile.file_path)" v-bind:key="'fileName' + fKey">
                            {{ uFile["file_name"] }}
                          </a>
                        </div>
                      </template>
                    </div>
                  </div>
              </div>

              <div class="col form-group section-divider">
                <label class="control-label" for="comment">Concern:</label>
                <p>{{ concern }}</p>
              </div>

              <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select"
                    id="ConcernForm">
                <div class="col form-group">
                  <h4>Review Concern</h4>
                </div>

                <div class="col form-row row">
                  <div class="col form-group">
                    <label class="control-label require" for="problemFound">Problem Found:</label>
                    <v-select v-model="problemFound"
                              id="problemFound" name="problemFound"
                              placeholder="Is Problem Found?" label="text"
                              :options="problemFoundOptions" class="close-remove"
                              @change="problemFoundChange($event)">
                    </v-select>
                    <span class="field-error">{{ problemFoundErrorMsg }}</span>
                  </div>
                  <div class="col form-group">
                    <label class="control-label require" for="userFeedbackStatus">Status:</label>
                    <v-select v-model="userFeedbackStatus"
                              :id="userFeedbackStatus" name="userFeedbackStatus"
                              placeholder="Select Status" label="text"
                              :options="userFeedbackStatusOptions" @change="statusChange($event)">
                    </v-select>
                    <span class="field-error">{{ userFeedbackStatusErrorMsg }}</span>
                  </div>
                  <div class="col form-group">
                    <label class="control-label" for="completeDate">Complete Date:</label>
                    <div class="input-group">
                      <date-picker placeholder="MM/DD/YYYY" id="completeDate"
                                   name="completeDate" :config="dateOptions"
                                   v-model="completeDate"
                                   ref="completeDate"></date-picker>
                      <label for="start_date"
                             class="fp-calendar input-calender-icon"></label>
                    </div>
                    <span class="field-error">{{ completeDateErrorMsg }}</span>
                  </div>
                </div>

                <div class="col form-row row">
                  <div class="col form-group">
                    <label class="control-label" for="cause">Cause:</label>
                    <textarea class="form-control" v-model="cause" ref="textarea" id="cause" rows="5"></textarea>
                    <span class="field-error">{{ causeErrorMsg }}</span>
                  </div>
                  <div class="col form-group">
                    <label class="control-label" for="correction">Correction:</label>
                    <textarea class="form-control" v-model="correction" ref="textarea" id="correction"
                              rows="5"></textarea>
                    <span class="field-error">{{ correctionErrorMsg }}</span>
                  </div>
                </div>

                <div class="col form-group" style="margin-bottom:35px">
                  <label class="control-label" for="internalNotes">Internal Notes:</label>
                  <textarea class="form-control" v-model="internalNotes" ref="textarea" id="internalNotes"
                            rows="5"></textarea>
                  <span class="field-error">{{ internalNotesErrorMsg }}</span>
                </div>

                <div class="btn-groups">
                  <button type="submit" id="createSrtBtn" class="btn btn-primary" v-on:click.prevent="submitForm">
                    Update
                  </button>
                  <button type="submit" id="cancelSrtBtn" class="btn btn-tertiary"
                          v-on:click.prevent="cancellationConfirmation">
                    <i class="fp-close"> </i> Cancel
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>Oops!</h1>
            <h2>403</h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import EventBus from "./event-bus";

import LoadingContent from "@/components/LoadingContent.vue";

Vue.component("loading-content", LoadingContent);
import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';

export default {
  name: "UserFeedbackUpdate",
  components: {
    clearCacheData: () => import('@/components/ClearCacheData'),
    appFooter: () => import('@/components/Footer'),
  },
  mixins: [commonMixins, contractMixins],
  metaInfo() {
    return {title: "Review User Concern | " + process.env.COPYRIGHT_NAME}
  },
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    loading: false,
    ticketNumber: "",
    status: "",
    category: "",
    user: "",
    submitDate: "",
    concern: "",
    name: "",
    email: "",
    phone: "",
    problemFound: "",
    completeDate: "",
    cause: "",
    correction: "",
    internalNotes: "",
    problemFoundErrorMsg: "",
    completeDateErrorMsg: "",
    causeErrorMsg: "",
    correctionErrorMsg: "",
    internalNotesErrorMsg: "",
    dateOptions: {
      format: 'MM/DD/YYYY',
      useCurrent: false
    },
    problemFoundOptions: ['Yes', 'No'],
    userFeedbackId: '',
    userFeedbackStatus: '',
    userFeedbackStatusOptions: ['Escalation', 'Closed', 'Open'],
    userFeedbackStatusErrorMsg: "",
    dropZonePreviewFiles: [],
    initialReportConcernFormData: '',
    reportConcernFormData: ''
  }),
  created: function () {

    this.logoPath = process.env.LOGO_PATH;
    this.flagPath = process.env.FLAG_LOGO_PATH;

  },
  watch: {
    //check permission change
    permissions: function (permissions) {
      if (permissions.length > 0) {
        for (const element of permissions) {
          if (element.name === 'ev_update_feedback') {
            this.cantAccessPage = true;
          }
        }
      }
    },
  },
  mounted: function () {
    this.getPermissions();
    var path = window.location.pathname;
    var segments = path.split("/");
    this.userFeedbackId = segments[3];
    this.loadUserFeedbackData();
  },
  methods: {
    cancellationConfirmation(){
      if (this.hasFormChanged()) {
        this.$swal({
          title: 'Are you sure you want to cancel feedback review?',
          type: 'warning',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          showCancelButton: true,
        }).then((result) => {
          if (result.value) {
            this.FeedBackLink();
          }
        });
      } else{
        this.FeedBackLink();
      }
    },
    problemFoundChange(newValue) {
      if (newValue == null || newValue == '') {
        this.problemFound = '';
      }
    },
    statusChange(newValue) {
      if (newValue == null || newValue == '') {
        this.userFeedbackStatus = '';
      }
    },
    FeedBackLink() {
      this.$router.push("/feedback-log");
    },
    loadUserFeedbackData() {
      var self = this;
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/user-feedback/view/" + self.userFeedbackId,
        type: "GET",
        headers: {
          "Accept": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Authorization": "Bearer " + localStorage.getItem("tkn"),
          "Access-Control-Allow-Headers":
            "Origin, Content-Type, Authorization,X-Requested-With",
          "Cache-Control": "no-cache"
        },
        crossDomain: true,
        processData: false,
        contentType: false,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          if (data.status === "success") {
            self.populateFields(data.content);
            if (
              data.content.viewed_mapper_id === undefined 
              ||
              !Number.isInteger(data.content.viewed_mapper_id) 
              ||
              data.content.viewed_mapper_id <= 0
            ) {
              self.updateViewedMapperId(data.content.id);
            }
          } else {
            console.log("Error!!");
          }
        },
        error: function (jqXHR) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, false, 'user-feedback-review')
        }
      })

    },
    updateViewedMapperId(id){
      var self = this;
      $.ajax({
        url: process.env.ROOT_API + "/user-feedback/update-viewed-mapper-id",
        type: "POST",
        data: {
          feedbackId: id
        },
        headers: {
          "Accept": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Authorization": "Bearer " + localStorage.getItem("tkn"),
          "Access-Control-Allow-Headers":
            "Origin, Content-Type, Authorization,X-Requested-With",
          "Cache-Control": "no-cache"
        },
        dataType: "json",
        success: function (data) {
            if (data.status == "success") {
              EventBus.$emit('updateCount', data.content, 'feedback');
          } else {
            console.log("Error!!");
          }
        },
        error: function (jqXHR) {
          self.generateStatusCodeMessage(
            jqXHR, 
            false, 
            'user-feedback-review-update-viewed-mapper-id'
          )
        }
      })
    },
    populateFields(fieldData) {
      this.ticketNumber = fieldData.ticket_number;
      this.status = this.titleCase(fieldData.status);
      this.category = fieldData.category;
      this.user = fieldData.created_by.username;
      this.submitDate = fieldData.submit_date;
      this.concern = fieldData.concern;
      this.name = this.capitalizeFirstLetters(fieldData.name);
      this.email = fieldData.email;
      this.phone = fieldData.phone;
      this.dropZonePreviewFiles = fieldData.attachment;
      this.problemFound = fieldData.problem_found;
      this.completeDate = fieldData.date_completed;
      this.cause = fieldData.cause;
      this.correction = fieldData.correction;
      this.internalNotes = fieldData.internal_notes;
      this.userFeedbackStatus = this.titleCase(fieldData.status);

      this.populateFormData(true);
    },


    submitForm() {
      var self = this;
      self.loading = true;
      var valid = self.validateFormFields()
      if(valid){
        let fields = self.prepareFormFields();
        $.ajax({
          url: process.env.ROOT_API + "/user-feedback/edit",
          type: "POST",
          data: fields,
          headers: {
            "Accept": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Authorization": "Bearer " + localStorage.getItem("tkn"),
            "Access-Control-Allow-Headers":
                "Origin, Content-Type, Authorization,X-Requested-With",
            "Cache-Control": "no-cache"
          },
          crossDomain: true,
          processData: false,
          contentType: false,
          dataType: "json",
          success: function (data) {
            self.loading = false;
            if (data.status === "success") {
              self.FeedBackLink();
            } else {
              console.log("Error!!");
            }
          },
          error: function (jqXHR) {
            self.loading = false;
            self.generateStatusCodeMessage(jqXHR, false, 'user-feedback-review-update')
          }
        })
      }else{
        self.loading = false;
      }

    },
    prepareFormFields() {
      var fields = {
        userFeedbackId: this.userFeedbackId,
        problemFound: this.problemFound,
        completeDate: this.completeDate,
        cause: this.cause,
        correction: this.correction,
        internalNotes: this.internalNotes,
        userFeedbackStatus: this.userFeedbackStatus
      }

      let formData = new FormData();
      formData.append("reviewData", JSON.stringify(fields));
      return formData;
    },
    validateFormFields(){
      var valid = true;
      this.clearErrorMessages();
      if(this.problemFound === "" || this.problemFound == null ){
        this.problemFoundErrorMsg = "Please specify if the problem is found or not!";
        valid = false;
      }
      if(this.userFeedbackStatus === "" || this.userFeedbackStatus == null ){
        this.userFeedbackStatusErrorMsg = "Please select status!";
        valid = false;
      }
      return valid;
    },
    clearErrorMessages(){
      this.problemFoundErrorMsg = "";
      this.userFeedbackStatusErrorMsg = "";
    },
    clearFormFields() {
      this.problemFound = "";
      this.completeDate = "";
      this.cause = "";
      this.correction = "";
      this.internalNotes = "";
      this.problemFoundErrorMsg = "";
      this.completeDateErrorMsg = "";
      this.causeErrorMsg = "";
      this.correctionErrorMsg = "";
      this.internalNotesErrorMsg = "";
    },
    goToGetDocumentPath(event, path) {
      event.preventDefault();
      var path = path;
      var flag = '';
      var id = 0;
      this.getDocumentPath(id, path, flag);
    },
    populateFormData(populateInitialData = false) {
      var formData = {
        problemFound: this.problemFound,
        userFeedbackStatus: this.userFeedbackStatus,
        completeDate: this.completeDate,
        cause: this.cause,
        correction: this.correction,
        internalNotes: this.internalNotes,
      }
      this.reportConcernFormData = JSON.stringify(formData);

      if (populateInitialData) {
        this.populateIntialFormData();
      }
    },
    populateIntialFormData() {
      this.initialReportConcernFormData = this.reportConcernFormData;
    },
    hasFormChanged() {
      this.populateFormData();
      // Compare the current form data with the initial form data
      return this.reportConcernFormData !== this.initialReportConcernFormData;
    },
  }
};
</script>

<style scoped>
.data-table table {
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/UserFeedbackUpdate.vue